import { render, staticRenderFns } from "./ServiceHistoryTable.vue?vue&type=template&id=22be958e"
import script from "./ServiceHistoryTable.vue?vue&type=script&lang=js"
export * from "./ServiceHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceHistoryTable.vue?vue&type=style&index=0&id=22be958e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports